import containers from './containers'
import components from './components'

export default {
  ...containers,
  ...components
}
